(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.test', {
                parent: 'admin',
                url: '/test',
                data: {
                    authorities: []
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/test/test.html',
                        controller: 'TestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
